/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/

// reactstrap components
import useWhiteLabel from 'hooks/useWhiteLabel';
import { Container, Row, Col } from 'reactstrap';

function AdminFooter() {
  const { isWhiteLabelTeam } = useWhiteLabel();

  return (
    <>
      <Container fluid className="d-print-none">
        <footer className="footer pt-0">
          <Row className="align-items-center justify-content-lg-between">
            <Col lg="6">
              {!isWhiteLabelTeam && (
                <div className="copyright text-center text-lg-left text-black">
                  © {new Date().getFullYear()}{' '}
                  <span className="font-weight-bold text-brand">Gather</span>
                </div>
              )}
            </Col>
          </Row>
        </footer>
      </Container>
    </>
  );
}

export default AdminFooter;
